import { atom } from 'jotai';

import { EquipmentDetailsResponse } from '@repo/sdk/models/components';

/**
 * The current equipment atom.
 * This is set when we fetch equipment for the equipment details drawer
 */

export const equipmentResponseAtom = atom<EquipmentDetailsResponse | undefined>(undefined);
equipmentResponseAtom.debugLabel = 'equipmentResponseAtom';

export const equipmentLoadingAtom = atom<boolean>(false);
equipmentLoadingAtom.debugLabel = 'equipmentLoadingAtom';
